/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { ConversationThreadContainer_story$ref } from "./ConversationThreadContainer_story.graphql";
import { CreateCommentMutation_story$ref } from "./CreateCommentMutation_story.graphql";
import { CreateCommentReplyMutation_story$ref } from "./CreateCommentReplyMutation_story.graphql";
import { ReplyListContainer1_story$ref } from "./ReplyListContainer1_story.graphql";
declare const _PermalinkViewContainer_story$ref: unique symbol;
export type PermalinkViewContainer_story$ref = typeof _PermalinkViewContainer_story$ref;
export type PermalinkViewContainer_story = {
    readonly " $fragmentRefs": ConversationThreadContainer_story$ref & ReplyListContainer1_story$ref & CreateCommentMutation_story$ref & CreateCommentReplyMutation_story$ref;
    readonly " $refType": PermalinkViewContainer_story$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PermalinkViewContainer_story",
    "type": "Story",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ConversationThreadContainer_story",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_story",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CreateCommentMutation_story",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CreateCommentReplyMutation_story",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'be7f7d77659f4a5ac01ee43ab64c9a89';
export default node;
